<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0015_device_embedded_information_pegging</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="証書情報（紐付証書）" >
          </title-and-slot>


          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A<br> -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-8" style="">
              <div class="row">
                <div class="col-xs-6" style="">
                  <!-- Coll B <br> -->
                  <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
                <div class="col-xs-6" style="">
                  <!-- Coll C<br> -->
                  <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" style="">
                  <field-box   v-for="f in formFields.col2b"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            　<h3>ソフトウェア情報</h3><br>
 　　　　　　　<sub-table-associated_device style="margin-bottom:20px"/>
            <!-- Should be a component -->
          </div>
                    <div style="margin-top:5px;">
            <button class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="backToList">＜　戻る</button>
            <router-link
              to="/device_embedded_information_pegging2"
              type="button"
              class="btn btn-primary btn-xs"
              style="float: right;margin-left:10px;"
           　 >紐付変更</router-link>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_certificate_information';
import subTableAssociatedDevice from '@/components/sub_pages/associated_device';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'sub-table-associated_device': subTableAssociatedDevice,
    'field-box': fieldBoxes
  },
  data() {
    return {
      api_name:"certificate_information",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      page_acl: acl.generic
    };
  },
  computed: {
    deviceControlNumber(){
      return this.$store.state[this.stateCurrentRow]["device_control_number"]
    },
    registrationDate(){
      return  utils.format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.certificate_management_number, {}),
          utils.extend(fields.licensed_department, {}),
          utils.extend(fields.license_jurisdiction_team, {}),
          utils.extend(fields.jurisdiction_classification, {}),
          utils.extend(fields.license_jurisdiction_system, {}),
          utils.extend(fields.license_certificate_type, {}),
          utils.extend(fields.certificate_individual_number, {}),
          utils.extend(fields.comprehensive_contract, {}),
          utils.extend(fields.sales_company, {}),
          utils.extend(fields.applicant_name, {}),
          utils.extend(fields.management_person_name, {}),
        ],
        col2:[
          utils.extend(fields.downgrade, {}),
          utils.extend(fields.expiration_date, {}),
          utils.extend(fields.maintenance_deadline, {}),
          utils.extend(fields.deadline_alert, {}),
        ],
        col3:[


        ],
        col2b:[
          utils.extend(fields.remark, {}),
          utils.extend(fields.other_items_by_manufacturer, {}),
        ],
      }
    }
  },
  methods: {
    onSave(){
      this.read_only = false;
      this.commonSaveInfo(this,this.api_name, {} );
    },
    onEdit(){
      mdebug("onEdit")
      setTimeout(() => {
        this.read_only = false;
      }, 300);
    },
    backToList(){
      return this. $router.go (-1);
    }
  },
  mounted() {
    mdebug("page_0015_device_embedded_information_pegging mounting");
    // TODO: should load the data here
    this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.seq_id, {}, (err, result) => {
      if(err){
        this.$notify({
          title: 'データの読込に失敗しました。',
          text: err,
          type: 'error',
          duration: 10000
        });
      }
      this.$store.state[this.stateCurrentRow]= result.data;

      mdebug("LOAD DATA",{err, result});
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

.bottom_tab  {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input{
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left:4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0015_device_embedded_information_pegging.vue?c021aaae